import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useFulfillmentPlannerContext } from '../../../../../../fulfillment-planner/context';
import { useVoidedFulfillmentsForFulfillmentPlan } from '../../../../../../hooks/entities/selectors/fulfillments';
import ReadOnlyRateCard from '../../../../rate-card/read-only/read-only-rate-card';
import { useFulfillmentPlanRateInfo } from '../../../../rate-card/use-fulfillment-plan-rate-info';
import { LabelDetailsActions } from './label-actions/label-details-actions';
import { useReadonlyRateCard } from './use-read-only-rate-card';

const ReadOnlyRateCardContainer = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useFulfillmentPlannerContext();

  const {
    serviceName,
    trackingNumber,
    trackingUrl,
    shipDate,
    totalCost,
    labelProviderId,
    fillProviderId,
    serviceId,
    isLocalDelivery,
    delegationDateTime,
    deliveryDate,
    pickupDate,
    isMarkAsShipped,
    carrierId,
  } = useReadonlyRateCard({ fulfillmentPlanId, fulfillmentId });

  const { isThirdPartyBilling, hasProvidedRate } = useFulfillmentPlanRateInfo(serviceId);

  const costReviewFulfillmentPlanIds = useMemo(() => [fulfillmentPlanId], [fulfillmentPlanId]);

  const voidedFulfillments = useVoidedFulfillmentsForFulfillmentPlan(fulfillmentPlanId);

  return (
    <ReadOnlyRateCard
      carrierId={carrierId}
      costReviewFulfillmentPlanIds={costReviewFulfillmentPlanIds}
      delegationDateTime={delegationDateTime}
      deliveryDate={deliveryDate}
      fillProviderId={fillProviderId}
      hasProvidedRate={hasProvidedRate}
      isLocalDelivery={isLocalDelivery}
      isMarkAsShipped={isMarkAsShipped}
      isThirdPartyBilling={isThirdPartyBilling}
      labelDetailsActions={<LabelDetailsActions fulfillmentId={fulfillmentId} />}
      labelProviderId={labelProviderId}
      pickupDate={pickupDate}
      serviceName={serviceName}
      shipDate={shipDate}
      totalCost={totalCost}
      trackingNumber={trackingNumber}
      trackingUrl={trackingUrl}
      voidedFulfillments={voidedFulfillments}
    />
  );
};

ReadOnlyRateCardContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export default ReadOnlyRateCardContainer;
